/* @flow */

import titleize from '../utils/titleize';
import formatarCep from './formatar-cep';
import { type Endereco } from './types';


const formatarEndereco = ({
    logradouro,
    numero,
    bairro,
    cidade,
    estado,
    cep,
}: Endereco) => titleize(
    `${logradouro}, ${numero} - ${bairro}, ${cidade} - ${estado}, ${formatarCep(cep)}`,
);

export default formatarEndereco;
